import { constRoute } from "@utils/route";
import { useNavigate } from "react-router-dom";

import style from "./style.module.scss";

import GoBack from "@components/common-components/go-back";
import { Col, Row } from "antd";
import React from "react";

const SelectEvaluateMode = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={style.selectModeWrapper}>
        <div className={style.selectModeContainer}>
          <h1 style={{ textAlign: "center", lineHeight: "130%" }}>
            Which would you like to do?
          </h1>
          <Row className={style.boxesContainer} gutter={20}>
            <Col md={12} xs={24} sm={24}>
              <div
                onClick={() =>
                  navigate(constRoute?.projectName + "/evaluate-quick")
                }
                className={style.quickAssessment}
              >
                <h4> Quick Assessment </h4>
                <p>
                  Easily upload your report through our conversational
                  interface.
                </p>
              </div>
            </Col>
            <Col md={12} xs={24} sm={24}>
              <div
                onClick={() => navigate(constRoute?.projectName + "/evaluate")}
                className={style.fullReport}
              >
                <h4>Full Report</h4>
                <p>
                  Copy and paste your prompts through sections to get a final
                  report.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className={style.btnDiv}>
        <div className={style.twoBtnDiv}>
          <div className={style.goBackBtnDiv}>
            <GoBack
              onClick={constRoute?.selectFunction}
              className={style.goBtn}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectEvaluateMode;
